import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Review } from '@models/review.model';
import { AuthService } from './auth.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class ReviewService {
  baseHref = `${environment.apiUrl}/reviews`;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  createReview(reviewData: Review): Observable<Review> {
    const url = `${this.baseHref}`;
    return this.http.post<Review>(url, reviewData);
  }

  getReviews(
    userId: number = null,
    pageNumber = null,
    role: 'to' | 'pp' = null,
  ): Observable<{ reviews: Review[]; hasMore: string }> {
    const id = userId || this.authService.getUserIdFromAuthToken();
    const url = `${this.baseHref}/user/${id}`;
    let params = new HttpParams();
    if (pageNumber) {
      params = params.set('pageNumber', pageNumber.toString());
    }
    if (role) {
      params = params.set('role', role);
    }
    return this.http.get<{ reviews: Review[]; hasMore: string }>(url, {
      params,
    });
  }

  getReceivedReviewsCount(userId: number = null): Observable<any> {
    const id = userId ?? this.authService.getUserIdFromAuthToken();
    if (!Number.isInteger(id)) {
      return;
    }
    const url = `${this.baseHref}/count/user/${id}`;
    // eslint-disable-next-line consistent-return
    return this.http.get<any>(url);
  }

  getCachedReceivedReviewsCount(userId: number = null): Observable<any> {
    const id = userId ?? this.authService.getUserIdFromAuthToken();
    if (!Number.isInteger(id)) {
      return;
    }
    const url = `${this.baseHref}/count/user/${id}`;
    // eslint-disable-next-line consistent-return
    return this.http.get<any>(url);
  }

  getReviewsForOffer(offerId: number): Observable<any> {
    if (!offerId || !Number.isInteger(offerId)) {
      throw new Error('Invalid offer id provided');
    }
    const url = `${this.baseHref}/offer/${offerId}`;
    return this.http.get<any>(url);
  }

  getPublicReviewsForOffer(offerId: number): Observable<any> {
    if (!offerId || !Number.isInteger(offerId)) {
      throw new Error('Invalid offer id provided');
    }
    const url = `${this.baseHref}/public/offer/${offerId}`;
    return this.http.get<any>(url);
  }
}
